import Icon from 'components/Icon';
import servises, { useGetShoppingCartDetailsQuery } from 'core/services';
import api from 'core/services/api';
import styled from 'hooks/styled';
import useSkipForProduct from 'hooks/useSkipForProduct.hook';
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

const { logout } = servises;

const Wrapper = styled('div')(() => ({
  marginTop: '60px',
  marginBottom: '32px',
  display: 'flex',
  gap: 8,
}));

const NavButton = styled(Link)(({ theme, counter }) => ({
  width: '76px',
  height: '76px',
  borderRadius: '16px',
  background: '#FFF',
  boxShadow: '0px 4px 8px 0px rgba(64, 62, 41, 0.18)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  cursor: 'pointer',
  position: 'relative',
  '&:hover': {
    opacity: '0.7',
  },
  '&::after': {
    content: `"${counter}"`,
    display: counter ? 'unset' : 'none',
    fontFamily: 'Nunito',
    fontSize: 12,
    fontWeight: 800,
    lineHeight: '18px',
    color: 'white',
    height: '18px',
    padding: '0px 5px',
    borderRadius: 9,
    background: theme.palette.primary.main,
    position: 'absolute',
    top: 12,
    right: 12,
  },
}));

const AccountNavigation = () => {
  const cart_id = useSelector((state) => state.cart.cart_id);
  const skipForProduct = useSkipForProduct();
  const { data } = useGetShoppingCartDetailsQuery(
    { cart_id },
    {
      skip: skipForProduct || !cart_id,
    },
  );

  const dispatch = useDispatch();

  const handleLogOut = useCallback(() => {
    logout();
    dispatch(api.util.resetApiState());
  }, [dispatch]);

  return (
    <Wrapper>
      <NavButton to="/cart" counter={data?.cart_total_items}>
        <Icon.EggEmpty fontSize={32} />
      </NavButton>
      <NavButton to="/profile/dashboard">
        <Icon.Person fontSize={32} />
      </NavButton>
      <NavButton to="/profile/lab">
        <Icon.TestTubes3 fontSize={32} />
      </NavButton>
      <NavButton to="/" onClick={handleLogOut}>
        <Icon.LogOut fontSize={32} />
      </NavButton>
    </Wrapper>
  );
};

export default AccountNavigation;
